import(/* webpackMode: "eager" */ "/vercel/path0/src/app/discover/rising/page.tsx");
